import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props) {
  let treatment_id = useDataValue({
    context: 'appointment_overlay',
    path: 'treatment_id',
    viewPath: props.viewPath,
  })

  return {
    variables: { treatment_id },
    requestPolicy: 'network-only',
    pause: !treatment_id,
  }
}
